import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/homeData";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState("hero");
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const ids = ["hero", ...navLinks.map((l) => l.id)];
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActive(entry.target.id);
        });
      },
      { rootMargin: "-45% 0px -50% 0px", threshold: 0 }
    );
    ids.forEach((id) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    setOpen(false);
  };

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors duration-300 ${
        scrolled
          ? "border-background-200 bg-background-50/90 backdrop-blur"
          : "border-transparent bg-background-50"
      }`}
    >
      <nav className="mx-auto flex h-16 w-full items-center justify-between gap-4 px-4 md:px-6">
        <a
          href="#hero"
          onClick={(e) => {
            e.preventDefault();
            goTo("hero");
          }}
          className="flex items-center gap-2.5"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-background-50">
            <i className="ri-play-circle-fill text-lg"></i>
          </span>
          <span className="flex flex-col leading-tight">
            <span className="font-heading text-base font-bold text-foreground-950">继母的诱惑</span>
            <span className="text-[11px] tracking-wide text-foreground-500">观看指南 · 资源导航</span>
          </span>
        </a>

        <ul className="hidden items-center gap-1 lg:flex">
          {navLinks.map((link) => (
            <li key={link.id}>
              <a
                href={`#${link.id}`}
                onClick={(e) => {
                  e.preventDefault();
                  goTo(link.id);
                }}
                className={`rounded-md px-3 py-2 text-sm transition-colors ${
                  active === link.id
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-600 hover:bg-background-100 hover:text-foreground-900"
                }`}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <button
          type="button"
          onClick={() => goTo("directory")}
          className="hidden whitespace-nowrap rounded-md bg-primary-600 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700 lg:inline-flex"
        >
          查看资源导航
        </button>

        <button
          type="button"
          aria-label={open ? "关闭菜单" : "打开菜单"}
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-800 lg:hidden"
        >
          <i className={open ? "ri-close-line text-lg" : "ri-menu-line text-lg"}></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <ul className="mx-auto flex w-full flex-col gap-1 px-4 py-3 md:px-6">
            {navLinks.map((link) => (
              <li key={link.id}>
                <a
                  href={`#${link.id}`}
                  onClick={(e) => {
                    e.preventDefault();
                    goTo(link.id);
                  }}
                  className={`flex items-center justify-between rounded-md px-3 py-2.5 text-sm ${
                    active === link.id
                      ? "bg-primary-100 text-primary-700"
                      : "text-foreground-700 hover:bg-background-100"
                  }`}
                >
                  {link.label}
                  <i className="ri-arrow-right-s-line text-foreground-400"></i>
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
}